import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { DEFAULT_SETTINGS_SECTION_ID } from '@/data/settingsNavData'
import { useSettingsModal } from '@/components/Settings/SettingsModal/SettingsModalContext'
import PATHS from '@/routes/paths'

/** Opens settings modal then returns to home (bookmarkable `/settings/:sectionId` URLs). */
export default function SettingsDeepLinkRoute() {
  const { sectionId } = useParams()
  const { openSettings } = useSettingsModal()

  useEffect(() => {
    openSettings(sectionId ?? DEFAULT_SETTINGS_SECTION_ID)
  }, [openSettings, sectionId])

  return <Navigate to={PATHS.HOME} replace />
}
